/**
 * Created by Administrator on 2019\1\17 0017.
 */
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'

// const httpOptions = {
//   headers: new HttpHeaders({ 'Content-Type': ' application/x-www-form-urlencoded;charset=utf-8' }),
// };

// const httpHeaders = {
//   headers: new HttpHeaders({ 'Content-Type': 'application/json' })
// };

@Injectable({ providedIn: 'root' })
export class HttpUtil {
  constructor(private http: HttpClient) {}

  public HttpUtil: any

  public formHeaders(): any {
    const merchantId = localStorage.getItem('merchantId') || ''
    const token = localStorage.getItem('token') || ''
    const headers = {
      'Content-Type': ' application/x-www-form-urlencoded;charset=utf-8',
      merchantId: '' + merchantId,
      token: '' + token,
    }
    return {
      headers: new HttpHeaders(headers),
    }
  }
  public jsonHeaders(): any {
    const merchantId = localStorage.getItem('merchantId') || ''
    const token = localStorage.getItem('token') || ''
    const headers = {
      'Content-Type': 'application/json',
      merchantId: '' + merchantId,
      token: '' + token,
    }
    return { headers: new HttpHeaders(headers) }
  }

  public post(url: string, data?: any): Observable<any> {
    const params = typeof data === 'object' && String(data) !== '[object File]' ? this.paramFormat(data) : data
    return this.http.post(url, params, this.formHeaders())
  }
  public postJson(url: string, data?: any): Observable<any> {
    console.log(url, data)
    return this.http.post(url, data, this.jsonHeaders())
  }
  public put(url: string, data?: any): Observable<any> {
    const params = typeof data === 'object' && String(data) !== '[object File]' ? this.paramFormat(data) : data
    return this.http.put(url, params, this.formHeaders())
  }
  public putJson(url: string, data?: any): Observable<any> {
    return this.http.put(url, data, this.jsonHeaders())
  }
  public delete(url: string, data?: any): Observable<any> {
    const params = typeof data === 'object' && String(data) !== '[object File]' ? this.paramFormat(data) : data
    return this.http.delete(url, params)
  }
  // public delete1(url: string, data?: any) {
  //   console.log('🚀 ~ file: common.http.ts ~ line 31 ~ data', data);
  //   // const params = typeof (data) === 'object' && String(data) !== '[object File]' ? this.paramFormat(data) : data;
  //   // console.log('🚀 ~ file: common.http.ts ~ line 32 ~ params', params);
  //   return this.http.delete(url, { params: data || {} });
  // }
  public get(url: string, data?: any): Observable<any> {
    return this.http.get(url, { ...data, ...this.jsonHeaders() })
  }

  public request(HttpRequest) {
    return this.http.request(HttpRequest)
  }

  // 序列化参数
  private paramFormat(data: any): string {
    let paramStr = '',
      name,
      value,
      subName,
      innerObj
    // tslint:disable-next-line:forin
    for (name in data) {
      value = data[name]
      if (value instanceof Array) {
        for (const i of value) {
          subName = name
          innerObj = {}
          innerObj[subName] = i
          paramStr += this.paramFormat(innerObj) + '&'
        }
      } else if (value instanceof Object) {
        Object.keys(value).forEach((key) => {
          subName = name + '[' + key + ']'
          innerObj = {}
          innerObj[subName] = value[key]
          console.log(innerObj)
          paramStr += this.paramFormat(innerObj) + '&'
          console.log(paramStr)
        })
      } else if (value !== undefined && value !== null) {
        paramStr += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&'
      }
    }
    return paramStr.length ? paramStr.substr(0, paramStr.length - 1) : paramStr
  }
}
